<template>
  <TransitionsFade>
    <div
      v-if="isOpen"
      class="fixed inset-0 z-10 bg-disabled-500/60 transition-opacity"
      :class="[{ 'backdrop-blur-sm': blurred }]"
      @click="close"
    />
  </TransitionsFade>
</template>

<script setup lang="ts">
import type { BackdropProps } from '~/components/ui/Backdrop/types';

const props = defineProps<BackdropProps>();

watch(
  () => props.isOpen,
  (isOpen) => {
    useHead({
      bodyAttrs: {
        class: isOpen ? 'overflow-hidden' : '',
        tagDuplicateStrategy: 'replace',
      },
    });
  },
  { immediate: true },
);
</script>
